var ACTDIG = ACTDIG || (ACTDIG = {});

ACTDIG.Ajax = (function ($, window, document) {

    /**
     * Check if form is valid and prevent default if not
     */
    function formValid(form) {
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();

            return false; // Not valid;
        }
        return true;
    }

    /**
     * Reset the form on success
     */
    function resetForm($form) {
        $form.trigger('reset');
        $form.removeClass('was-validated');
        $form[0].reset();
    }

    /**
     * Handle ajax submitting of the form
     */
    function handleAjax($form, callback, shouldResetForm) {
        $form.find('[type=submit]').prop('disabled', true);
        $form.parent().find('.response-alert').slideUp();
        $form.parent().find('.response-alert').find('span.txt').html('');

        $.ajax({
            type: 'post',
            dataType: 'json',
            cache: false,
            url: ACTDIG_ROUTES.ajax_url,
            data: {
                action: $form.find('[name=action]').val(),
                security: ACTDIG_ROUTES.ajax_nonce,
                data: $form.serialize(),
            },
            success: function (response) {
                if (callback) {
                    callback($form, response);
                }

                showAlert($form, response.message, response.status);

                if (shouldResetForm) {
                    resetForm($form);
                }
            },
            error: function () {
                showAlert($form, 'Something went wrong. Please try again', 'danger');
            },
            complete: function (response) {
                $form.find('[type=submit]').prop('disabled', false);
            }
        });
    }

    /**
     * Show response message in alert
     */
    function showAlert($form, message, type) {
        var c = 'alert-' + type;
        var alert = $form.parent().find('.response-alert');

        if (alert.length) {
            alert
                .removeClass('alert-danger', 'alert-success', 'alert-info')
                .addClass(c);

            alert.find('span.txt').html(message);

            alert.slideDown();
        }
    }

    /**
     * Global form event handler wrap
     */
    function eventHandler(_this, callback) {
        if (formValid(_this)) {
            handleAjax($(_this), callback, true);
        }
    }

    return {
        init: function () {
            $(document).find('form[data-ajax-submit]').on('submit', function (e) {
                e.preventDefault();
                eventHandler(this, null);
            });
        }
    };
})(window.jQuery, window, document);